import React from 'react'
import "./Team1.css"

const Team1 = () => {
  return (
    <div className='team'>
      <div className="team1">
        <h1>Meet the Team</h1>
      </div>

    </div>
  )
}

export default Team1